<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actCatMain">
          <v-card id="actCatCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.lines") }}</v-card-title>
            <v-data-table id="actCatTable" :headers="headers" :items="items" :items-per-page="-1" :sort-by="['activityCategoryCode']" :sort-desc="[false]" class="elevation-0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.lineCode }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: center">
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field class="form-control" v-model="editedItem.lineCode" :rules="[() => !!editedItem.lineCode || requiredMessage]" required readonly="true" >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.lineCode") }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field class="form-control" v-model="editedItem.description" :rules="[() => !!editedItem.description || requiredMessage]" required>
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.description") }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      showDialog: false,
      requiredMessage: this.$t("common.required"),
      headers: [
        {
          text: this.$t("column.lineCode"),
          align: "left",
          sortable: true,
          value: "lineCode",
          width: "20%",
        },
        {
          text: this.$t("column.description"),
          align: "left",
          value: "description",
        },

        {
          text: this.$t("column.actions"),
          align: "center",
          value: "actCatactions",
          sortable: false,
          width: "20%",
        },
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      dialogImport: false,
      showError: false,
      selectedPvId: null,
      importDlg: {
        projectId: null,
        vesselId: null,
      },
    };
  },
  computed: {
    ...mapGetters(["m_cable/getLines"]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("nav.lines") : this.$t("common.edit") + " " + this.$t("nav.lines");
    },

    items() {
      return this["m_cable/getLines"];
    },

    formIsValid() {
      return this.editedItem.lineCode && this.editedItem.description;
    },
  },
  watch: {
    showDialog(val) {
      val || this.close();
    },
  },

  created() {
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this.$log.debug("loading lines for", this.selProjectId, this.selVesselId);
    this.refreshLines();
  },

  methods: {
    ...mapMutations(["mHideLongLoader", "mShowInfoMessage"]),
    ...mapActions(["m_cable/fetchLines", "m_cable/updateLine"]),

    refreshLines() {
      this["m_cable/fetchLines"]({
        pId: this.selProjectId,
        vId: this.selVesselId,
      });
    },

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1;
      this.editedItem = Object.assign({}, item || this.defaultItem);
    },

    editItem(item) {
      this.resetEntity(item);
      this.showDialog = true;
    },

    close() {
      this.$refs.form.resetValidation();
      this.showDialog = false;
    },

    save() {
      if (~this.editedIndex) {
        this["m_cable/updateLine"](this.editedItem).then(this.refreshLines);
      }
      this.close();
    },
  },
};
</script>

<style>
#actCatTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#actCatTable header {
  font-weight: bold;
}
#actCatCard {
  width: auto;
}
</style>
